<template>
  <EUIFooter :links="links">
    <template slot="terms">
      <span>
        The information is general in nature and does not constitute financial
        or tax advice. Independent financial and/or tax advice should be sought.
        You should read the relevant Product Disclosure Statement available by
        calling FleetPlus on 1300 353 381 and consider whether the insurance
        product is right for you before making any decision. FleetPlus Pty Ltd
        is an Authorised Representative (AR No. 270321) of the insurance issuers
        ERIC Insurance Limited (ABN 18 009 129 793) (AFSL 238279) and Allianz
        Australia Insurance Limited (ABN 15 000 122 850) (AFSL 23408).
      </span>
      <span>
        All applications for credit are subject to credit approval criteria.
        Terms and conditions, fees and charges apply.
      </span>
      <span>
        © 2020 FleetPlus Pty Ltd ABN 59 099 217 320 is a wholly owned subsidiary
        of Eclipx Group Limited ABN 85 131 557 901 ASX:ECX
      </span>
    </template>
    <template slot="logos">
      <a :href="logos.eclipx.href" target="_blank">
        <QIcon
          :name="logos.eclipx.imageHref"
          class="primary-logo"
          style="width: 79px;"
        />
      </a>
      <QSeparator vertical color="grey-7" class="q-mx-lg logo-separator" />
      <a :href="logos.fleetChoice.href" target="_blank">
        <QIcon
          :name="logos.fleetChoice.imageHref"
          class="logo q-mr-lg"
          style="width: 125px;"
        />
      </a>
      <a :href="logos.fleetPartners.href" target="_blank">
        <QIcon
          :name="logos.fleetPartners.imageHref"
          class="logo q-mr-lg"
          style="width: 97px;"
        />
      </a>
      <a :href="logos.fleetPlus.href" target="_blank">
        <QIcon
          :name="logos.fleetPlus.imageHref"
          class="logo"
          style="width: 105px;"
        />
      </a>
    </template>
  </EUIFooter>
</template>
<script>
import { QIcon, EUIFooter, QSeparator } from 'eclipx.ui';

/**
 * This component represents the footer which is to be displayed as part of all page layouts.
 */
export default {
  name: 'Terms',
  data() {
    return {
      links: {
        'Terms Of Use': `${process.env.BASE_URL}assets/legal/TermsAndConditions.pdf`,
        'Privacy Policy': 'http://eclipxgroup.com/privacy-policy'
      },
      logos: {
        eclipx: {
          imageHref: `img:${process.env.BASE_URL}assets/logos/EclipxLogo-small.svg`,
          href: process.env.VUE_APP_ECLIPX_HREF
        },
        fleetChoice: {
          imageHref: `img:${process.env.BASE_URL}assets/logos/FleetChoice-small.svg`,
          href: process.env.VUE_APP_FLEET_CHOICE_HREF
        },
        fleetPartners: {
          imageHref: `img:${process.env.BASE_URL}assets/logos/FleetPartners-small.svg`,
          href: process.env.VUE_APP_FLEET_PARTNERS_HREF
        },
        fleetPlus: {
          imageHref: `img:${process.env.BASE_URL}assets/logos/FleetPlus-small.svg`,
          href: process.env.VUE_APP_FLEET_PLUS_HREF
        }
      }
    };
  },
  components: {
    QSeparator,
    EUIFooter,
    QIcon
  }
};
</script>
<style lang="sass" scoped>
.link
  text-decoration: none
  color: $grey-7
  &:hover
    color: $grey-8
  &:active
    color: $grey-7

.primary-logo
  height: 40px

.logo-separator
  align-self: center
  height: 30px

.logo
  height: 30px
</style>
